import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { assetUrl } from '../../utils/assets';

interface ConsultationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: {
    serviceType: 'chat' | 'video';
    waktu: 'sekarang' | 'jadwal';
    layanan: string;
  }) => void;
  isOnline: boolean;
  prices: {
    chat?: number;
    video?: number;
  };
}

const Service: React.FC<ConsultationModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isOnline,
  prices
}) => {
  const [waktu, setWaktu] = useState<'sekarang' | 'jadwal'>('sekarang');
  const [serviceType, setServiceType] = useState<'chat' | 'video'>('chat');
  const [layanan, setLayanan] = useState('Chat dengan Dokter');

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-lg relative">
        <button
          className="absolute top-3 right-3 text-gray-500"
          onClick={onClose}
        >
          <FaTimes />
        </button>

        <h3 className="text-lg font-semibold text-center mb-4">Pilih Layanan</h3>

        {/* Pilih waktu konsultasi */}
        <div className="mb-4">
          <h4 className="font-semibold mb-1">Waktu Konsultasi</h4>
          <p className="text-sm text-gray-500 mb-2">
            Silahkan Pilih Waktu Konsultasi yang Anda butuhkan
          </p>

          <div className="space-y-2">
             {isOnline && (
              <label className="flex items-center gap-3 p-2 border rounded-lg cursor-pointer">
                <input
                  type="radio"
                  value="sekarang"
                  checked={waktu === 'sekarang'}
                  onChange={() => setWaktu('sekarang')}
                />
                <div>
                  <p className="font-medium">Konsultasi Sekarang</p>
                  <p className="text-xs text-gray-500">Mulai konsultasi sekarang</p>
                </div>
              </label>
            )}          
          </div>
        </div>

        <div className='flex flex-col mb-3'>
          <h4 className="font-semibold mb-1">Pilih Layanan</h4>
          <p className="text-sm text-gray-500 mb-2">
            Silahkan Pilih Layanan yang Anda butuhkan
          </p>

          <label
            className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition mb-3
              ${serviceType === 'chat' ? 'border-morning-300 bg-morning-50' : 'border-gray-200'}
            `}
          >
            <input
              type="radio"
              className="hidden"
              checked={serviceType === 'chat'}
              onChange={() => setServiceType('chat')}
            />
            <img
              src={assetUrl(serviceType === 'chat' ? 'icons/chat-fill.svg' : 'icons/chat.svg')}
              alt="Chat"
              className="w-5 h-5"
            />
            <div>
              <p className="text-xs text-gray-500">Chat dengan Dokter</p>
              <p className="text-md font-semibold">
                Rp {prices.chat?.toLocaleString('id-ID')}
              </p>
            </div>
          </label>

          {/* <label
            className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer transition
              ${price === 'video' ? 'border-morning-300 bg-morning-50' : 'border-gray-200'}
            `}
          >
            <input
              type="radio"
              className="hidden"
              checked={serviceType === 'video'}
              onChange={() => setServiceType('video')}
            />
            <img
              src={assetUrl(serviceType === 'video' ? 'icons/call-fill.svg' : 'icons/call.svg')}
              alt="Video Call"
              className="w-5 h-5"
            />
            <div>
              <p className="text-xs text-gray-500">Video Call (+ Chat)</p>
              <p className="text-md font-semibold">
                Rp {prices.video?.toLocaleString('id-ID')}
              </p>
            </div>
          </label> */}
        </div>

        <button
          className="w-full bg-morning-300 text-white py-2 rounded-full font-semibold"
          onClick={() => onSubmit({ waktu, serviceType, layanan })}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default Service;
